export type TagOption = { name: string; color?: string | null }

/** The same tag name can have a TagColor row per entity/scope. Dedupe by name for the picker,
 *  preferring an entry that actually carries a colour. */
export function dedupeTagsByName(hits: TagOption[]): TagOption[] {
  const byName = new Map<string, TagOption>()
  for (const tag of hits) {
    const existing = byName.get(tag.name)
    if (!existing || (!existing.color && tag.color)) byName.set(tag.name, { name: tag.name, color: tag.color })
  }
  return [...byName.values()]
}
